import { useTranslate } from '../../hooks'
import { formatNumberWithCommas, removeCommasFromNumber } from '@repo/tools'
import { Col, Input, InputNumericStepper } from '@repo/ui/components'
import { useIsDesktop } from '@repo/ui/hooks'
import type { AdvancedTradeBoxPriceInputProps } from './advanced-trade-box.types'

export const AdvancedTradeBoxPriceInput = ({
  value,
  onChange,
  label,
  onPriceChange,
  placeholder,
}: AdvancedTradeBoxPriceInputProps) => {
  const { t } = useTranslate()
  const isDesktop = useIsDesktop()

  return (
    <Col className='gap-xs'>
      {label && isDesktop && (
        <span className='font-bold text-xs text-neutral-surface-80'>
          {label}
        </span>
      )}
      {isDesktop ? (
        <Input
          type='text'
          value={formatNumberWithCommas(value)}
          onChange={(e) => {
            const cleanValue = removeCommasFromNumber(e.target.value)
            const newValue = Number(cleanValue) || 0
            onChange(newValue)
            onPriceChange?.(newValue)
          }}
          min={0}
          inputSize='md'
          endLabel={t('currency_toman')}
          className='flex-1'
        />
      ) : (
        <InputNumericStepper
          value={formatNumberWithCommas(value)}
          onChange={(e) => {
            const cleanValue = removeCommasFromNumber(e.target.value)
            const newValue = Number(cleanValue) || 0
            onChange(newValue)
            onPriceChange?.(newValue)
          }}
          min={0}
          step={1}
          inputSize='sm'
          className='w-full ltr'
          placeholder={placeholder || t('common_price_placeholder')}
        />
      )}
    </Col>
  )
}
